import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
//Limitless import
import { log as pilog } from "@limitless/common/utils";
import { handleAPIFailure } from "@limitless/common/utils/api-log-helper/APILogHelper";
import { refreshToken } from "@limitless/expert/apis/authentication-api/AuthenticationAPI";

/**
 * Axios Interceptor used for conditional handling of responses
 */
export const setupAxiosInterceptors = unauthorisedCallback => {
  // Instantiate the interceptor
  createAuthRefreshInterceptor(axios, failedRequest => {
    return new Promise((resolve, reject) => {
      refreshToken().then(session => {
        var _session$idToken;
        failedRequest.response.config.headers["Authorization"] = (_session$idToken = session.idToken) === null || _session$idToken === void 0 ? void 0 : _session$idToken.jwtToken;
        resolve();
      }).catch(e => {
        unauthorisedCallback();
        const log = pilog.getLogger("SecurePlatformAPIUtils interceptor");
        log.error("Unauthorised access, redirecting to Login %o", e);
        reject();
      });
    });
  }, {
    //2003 is platform code for not authorised
    shouldRefresh: error => {
      var _error$response, _error$response2, _error$response2$data;
      return (error === null || error === void 0 ? void 0 : (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401 || (error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.code) === "2003";
    }
  });
};

/**
 * Helper method to process an AJAX error.
 *
 * @param {object} error
 * @param {string} className
 * @param {function} dispatch
 * @param {string} customerMessage
 * @param {object} supressLoggingCodes
 */
export const handleSecureAjaxError = (error, className, dispatch, customerMessage, supressLoggingCodes) => {
  handleAPIFailure(error, className, customerMessage, supressLoggingCodes);
};
export const getAccessKeysFromStorage = () => {
  const log = pilog.getLogger("SecurePlatformAPIUtils getAccessKeysFromStorage");
  let n = 0;
  const localStorageData = {};
  while (n < localStorage.length) {
    localStorageData[localStorage.key(n)] = localStorage.getItem(localStorage.key(n));
    n++;
  }
  log.debug("LocalStorageData retreived ", localStorageData);
  return localStorageData;
};

/**
 * Creates the limitless platform API URL based on environment variables.
 *
 * @param {string} api
 */
export const createPlatformURL = (api, encode = true) => {
  const platformURL = `${process.env.REACT_APP_BASE_PLATFORM_URL}${process.env.REACT_APP_STAGE}/${api}`;
  return encode ? encodeURI(platformURL) : platformURL;
};

/**
 * Creates the headers needed for a mution AJAX call (POST/PUT)
 *
 *
 * @param {string} accessKey
 */
export const createMutationHeaders = (additionalParams, additionalHeaders) => {
  const storage = getAccessKeysFromStorage();
  const token = storage[`CognitoIdentityServiceProvider.${process.env.REACT_APP_CLIENT_ID}.${storage[`CognitoIdentityServiceProvider.${process.env.REACT_APP_CLIENT_ID}.LastAuthUser`]}.idToken`];
  return {
    headers: Object.assign({
      Authorization: token
    }, additionalHeaders),
    timeout: parseInt(process.env.REACT_APP_HTTP_POST_TIMEOUT),
    params: Object.assign({}, additionalParams)
  };
};